import { eventKeyConstants } from './eventKey';

const arrowDownNav = (event: any, currEmojiIndex: number, currEmojiArr: any, listLen: number) => {
    const currRow = Math.ceil((currEmojiIndex + 1) / listLen);
    const nextRow = Math.ceil(currEmojiArr.length / listLen);
    const currPos = (currEmojiIndex + 1) % listLen;
    if (nextRow > currRow) {
        (currEmojiArr[currEmojiArr.length - 1] as HTMLElement)?.focus();
    } else {
        const nextEmojis = event.target.closest('[data-emojiwrap]');
        const nextEmojiSelect = nextEmojis.nextSibling?.querySelectorAll('[data-emoji-type]')
            ?? nextEmojis.parentNode.firstChild?.querySelectorAll('[data-emoji-type]');
        if (Object.keys(nextEmojiSelect).length !== 0) {
            const pos = currPos === 0 ? listLen - 1 : currPos - 1;
            const nextEmojisArr = Array.prototype.slice.call(nextEmojiSelect);
            nextEmojisArr[pos]?.focus();
        }
    }
}

const arrowUpNav = (event:any, currPos: number, listLen: number) => {
    const prevEmojis = event.target.closest('[data-emojiwrap]');
    const prevEmojiSelect = prevEmojis.previousSibling?.querySelectorAll('[data-emoji-type]')
        ?? prevEmojis.parentNode.lastChild?.querySelectorAll('[data-emoji-type]');
    if (Object.keys(prevEmojiSelect).length !== 0) {
        const prevEmojisArr = Array.prototype.slice.call(prevEmojiSelect);
        const prevRow = Math.ceil(prevEmojiSelect.length / listLen);
        const pos = currPos === 0 ? listLen : currPos;
        if (prevEmojisArr[((prevRow - 1) * listLen) + pos - 1]) {
            prevEmojisArr[((prevRow - 1) * listLen) + pos - 1]?.focus();
        } else {
            prevEmojisArr[prevEmojisArr.length - 1]?.focus();
        }
    }
}

const arrowUpInitNav = (event, currEmojiArr, currEmojiIndex, listLen) => {
    if (currEmojiArr[currEmojiIndex - listLen]) {
        (currEmojiArr[currEmojiIndex - listLen] as HTMLElement)?.focus();
    } else {
        const currRow = Math.floor((currEmojiIndex + 1) / listLen);
        const currPos = (currEmojiIndex + 1) % listLen;
        if (!(currRow < 1 || (currPos === 0 && currRow === 1))) {
            (currEmojiArr[currEmojiArr.length - 1] as HTMLElement)?.focus();
        } else {
            arrowUpNav(event, currPos, listLen);
        }
    }
}

export const emojiKeyNav = (event : any, refID : string, listLen: number, cb : any, escCb: any) => {
    const refElem = document.getElementById(refID);
    const focusableElements = refElem.querySelectorAll(
        '[role="menuitem"]'
    );
    const focusableRowArr = Array.prototype.slice.call(focusableElements);
    const focusRowIndex = focusableRowArr?.indexOf(event.target);

    const emojiType = event.target.attributes['data-emoji-type']?.value;
    const queryEmojis = refElem.querySelectorAll(`[data-emoji-type="${emojiType}"]`);
    const currEmojiArr = Array.prototype.slice.call(queryEmojis);
    const currEmojiIndex = currEmojiArr?.indexOf(event.target);

    switch (event.key) {
        case eventKeyConstants.SPACE:
        case eventKeyConstants.ENTER:
            event.preventDefault();
            cb();
            break;
        case eventKeyConstants.ARROWUP:
            event.preventDefault();
            arrowUpInitNav(event, currEmojiArr, currEmojiIndex, listLen);
            break;
        case eventKeyConstants.ARROWDOWN:
            event.preventDefault();
            if (currEmojiArr[currEmojiIndex + listLen]) {
                (currEmojiArr[currEmojiIndex + listLen] as HTMLElement).focus();
            } else {
                arrowDownNav(event, currEmojiIndex, currEmojiArr, listLen);
            }
            break;
        case eventKeyConstants.ARROWLEFT:
            event.preventDefault();
            if (focusRowIndex === 0) {
                (focusableRowArr[focusableRowArr.length - 1] as HTMLElement)?.focus();
            } else {
                (focusableRowArr[focusRowIndex - 1] as HTMLElement)?.focus();
            }
            break;
        case eventKeyConstants.ARROWRIGHT:
            event.preventDefault();
            if (focusRowIndex === focusableRowArr.length - 1) {
                (focusableRowArr[0] as HTMLElement)?.focus();
            } else {
                (focusableRowArr[focusRowIndex + 1] as HTMLElement)?.focus();
            }
            break;
        case eventKeyConstants.TAB:
        case eventKeyConstants.ESCAPE:
            event.stopPropagation();
            event.preventDefault();
            escCb();
            break;
        default:
            // not to prevent synthetic events for other keys
            break;
    }
}
